import { GetAmbulatorySchedulePanelOrganized } from 'domain/usecases/ambulatory/get-ambulatory-panel-organized'
import { AmbulatoryRepository } from 'repository/interfaces/ambulatory-repository'

export class RemoteGetAmbulatorySchedulePanelOrganized
  implements GetAmbulatorySchedulePanelOrganized
{
  private readonly ambulatoryRepository: AmbulatoryRepository

  constructor(ambulatoryRepository: AmbulatoryRepository) {
    this.ambulatoryRepository = ambulatoryRepository
  }

  get(
    params: GetAmbulatorySchedulePanelOrganized.Params
  ): Promise<GetAmbulatorySchedulePanelOrganized.Model> {
    return this.ambulatoryRepository.getAmbulatorySchedulePanelOrganized(params)
  }
}
